// extracted by mini-css-extract-plugin
module.exports = {"svg":"SvgWave_svg__n43Hk","mobileSvg":"SvgWave_mobileSvg__1CRxZ"};